import User from '@alltrails/shared/types/User';
import classNames from 'classnames';
import Typography from 'components/Typography';
import useUser from 'hooks/useUser';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as styles from './Toast.module.scss';

// Desktop: https://zpl.io/B1ke0rK
// Mobile: https://zpl.io/z8l7d94

const autoHideDurationMs = 3400;

// this is a one off for now that can be refactored later if design starts using it in multiple spots
export default function Toast() {
  const [open, setIsToastOpen] = useState(false);
  const user = useUser();

  const previousUser = useRef<User>(user);

  useEffect(() => {
    if (!previousUser.current && user) {
      setIsToastOpen(true);
    }

    previousUser.current = user;
  }, [setIsToastOpen, user]);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setIsToastOpen(false);
      }, autoHideDurationMs);
    }
  }, [open]);

  if (open) {
    return (
      <div className={classNames(styles.wrapper)}>
        <div className={styles.toast}>
          <Typography variant="body2">
            <FormattedMessage defaultMessage="Welcome, {name}!" values={{ name: user?.firstName }} />
          </Typography>
        </div>
      </div>
    );
  }

  return null;
}
